import TrainTabs from "./TrainTabs";

export default TrainTabs;
